import { useQueryClient } from 'react-query'

const useInvalidateQueries = () => {
  const queryClient = useQueryClient()
  return queryKey => queryClient.invalidateQueries(queryKey)
}

export default useInvalidateQueries
